<template>
  <div>
    <v-container>
      <v-layout xs6 md6 sm6 lg6 xl6>
     <v-flex  xs6 md6 sm6 lg6 xl6 class="mt-4 mr-8">
            <v-text-field label="Name" v-model="name"></v-text-field>
            <v-text-field label="Email" v-model="iglo"></v-text-field>
            <v-text-field label="Roll Number" v-model="roll"></v-text-field>
            <v-text-field label="Password" v-model="password"></v-text-field>
            <v-btn class="ma-6" type="submit" v-on:click.prevent="register" >Submit</v-btn>
             <v-btn class="ma-6" link to="/">Login</v-btn><!--<h3>Or Login Using :</h3>
            <v-btn class="ma-6">
              <v-icon>bubble_chart</v-icon>Google
            </v-btn> -->
          </v-flex>
          </v-layout>
    </v-container>
  </div>
  
</template>
<script src="https://www.gstatic.com/firebasejs/7.22.0/firebase-app.js"></script>
<script src="https://www.gstatic.com/firebasejs/7.22.0/firebase-database.js"></script>
<script src="https://www.gstatic.com/firebasejs/7.22.0/firebase-auth.js"></script>
<script src="https://www.gstatic.com/firebasejs/7.22.0/firebase-storage.js"></script>
<script>
import {auth} from '../components/firebaseinit'
import db from '../components/firebaseinit';
import 'firebase/auth';
export default {
  data(){
    return {
      iglo:null,
      password:null,
      students:[],
      name:null,
      roll:null
    }
  },
  methods:{
    register:function(){
      console.log("hi")
      // console.log(this.iglo)
      // console.log(this.password)
      db.collection('students').add({
        Name:this.name,
        RollNo:this.roll,
        Mail:this.iglo
      }).then(doc =>{
      auth.createUserWithEmailAndPassword(this.iglo,this.password).then(user =>{
        console.log("hello")
        alert('Account created for '+ user.user.email);
        this.$router.go(this.$router.push('/'));
      },
      err =>{
        alert(err.message);
      });
      }).catch(err => console.log(err))
      // e.preventDefault();
      
    }
  }
}
</script>

<style>

</style>